import styled from 'styled-components';

export const MIN_HEIGHT = 38;

interface TextAreaSCProps {
  variation: 'lined' | 'round' | 'table';
  error?: React.ReactNode;
  disabled?: boolean;
}

export const TextAreaSC = styled.div<TextAreaSCProps>`
  line-height: 1;

  textarea {
    overflow: hidden;
    width: 100%;
    height: ${MIN_HEIGHT}px;
    border: none;
    border-bottom: 1px solid
      ${({ error }) => (error ? 'rgba(255,51,92,1)' : 'rgba(51, 61, 108, 1)')};

    font-size: 14px;
    padding: 0;
    padding-top: 12px;
    padding-left: 8px;
    background: transparent;
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};

    &:hover,
    &:active,
    &:focus {
      outline: none;
    }

    ::placeholder {
      color: rgba(51, 61, 108, 0.5);
    }
  }
`;
